import React from 'react'
import PropTypes from 'prop-types'

const TextInput = ({
  className,
  disabled,
  errorMessage,
  name,
  placeholder,
  readOnly,
  size,
  value,
  onChange,
  onClick
}) => {
  const hasError = Boolean(errorMessage)
  const sizeClass = size === 'sm' ? 'form-control-sm' : ''
  const errorClass = hasError ? 'is-invalid' : ''
  const classes = `form-control rounded ${sizeClass} ${errorClass} ${className}`.trim()

  return (
    <div>
      <input
        className={classes}
        disabled={disabled}
        name={name}
        placeholder={placeholder}
        readOnly={readOnly}
        type="text"
        value={value}
        onChange={onChange}
        onClick={onClick}
      />
      {hasError ? (
        <div className="text-danger small mt-1">
          {errorMessage}
        </div>
      ) : null}
    </div>
  )
}

TextInput.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  size: PropTypes.oneOf(['sm']),
  value: PropTypes.string
}

TextInput.defaultProps = {
  className: '',
  disabled: false,
  errorMessage: '',
  name: null,
  onChange: () => null,
  onClick: null,
  placeholder: '',
  readOnly: false,
  size: null,
  value: ''
}

export default TextInput
